import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Col, Row } from 'reactstrap';
import hasPermission from '../../../../Shared/hasPermission';
import PracticeName from './PracticeName';
import Bookmark from '../../../../Shared/Bookmark';
import Address from './Address';
import Contact from './Contact';
import Email from './Email';
import PhoneNumber from './PhoneNumber';
import PracticeGroup from './PracticeGroup';
import Website from './Website';
import PracticeEditingForm from '../../../../Forms/PracticeEditingForm';
import Mute from '../../../../Shared/Mute';

// TODO: talk over if breaking this up further is worth it
const PracticeDetails = () => {
    const isEditingPractice = useSelector(
        (state) => state.toggle.isEditingPractice
    );

    const {
        practiceId,
        isBookmarked,
        practiceName,
        practiceCity,
        practiceStateProvince,
        practiceGroupName,
        phoneNumber,
        primaryContact,
        practiceEmail,
        practiceWebsite,
        practiceAddress,
        postalCode,
    } = useSelector(selectPracticeInfo, shallowEqual);

    let practiceMute = useSelector(
        (state) => state.practice.practice?.practiceMute,
        shallowEqual
    );
    practiceMute = practiceMute ?? {};
    const {
        muteUntil = 0,
        muteNote = null,
        muteReasonName = null,
    } = practiceMute;

    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );
    const canMute = hasPermission(`Muting`, permissions);
    const canManagePracticeGroups = hasPermission(
        `ManagePracticeGroups`,
        permissions
    );

    const bookmarkProps = { practiceId, isBookmarked };
    const muteProps = {
        id: practiceId,
        name: practiceName,
        muteUntil,
        muteNote,
        muteReasonName,
    };
    const addressProps = {
        practiceAddress,
        practiceCity,
        practiceStateProvince,
        postalCode,
    };
    const editFormProps = { canManagePracticeGroups };
    return (
        <div className={classes} style={style}>
            {!isEditingPractice ? (
                <Row>
                    <PracticeName practiceName={practiceName} />
                    <div className="w-100 d-flex justify-content-start px-2">
                        <Col className="flex-grow-0">
                            <Bookmark {...bookmarkProps} />
                        </Col>
                        {canMute && (
                            <Col className="flex-grow-0">
                                <Mute {...muteProps} />
                            </Col>
                        )}
                        <PracticeGroup practiceGroupName={practiceGroupName} />
                    </div>
                    <PhoneNumber phoneNumber={phoneNumber} />
                    <Contact primaryContact={primaryContact} />
                    <Email practiceEmail={practiceEmail} />
                    <Website practiceWebsite={practiceWebsite} />
                    <Address {...addressProps} />
                </Row>
            ) : (
                // When visible practice sync stops
                <PracticeEditingForm {...editFormProps} />
            )}
        </div>
    );
};

const selectPracticeInfo = (state) => {
    const {
        id: practiceId,
        isBookmarked,
        name: practiceName,
        city: practiceCity,
        stateProvince: practiceStateProvince,
        groupName: practiceGroupName,
        phone: phoneNumber,
        primaryContact,
        email: practiceEmail,
        website: practiceWebsite,
        address: practiceAddress,
        postalCode = '',
    } = state.practice.practice;
    return {
        practiceId,
        isBookmarked,
        practiceName,
        practiceCity,
        practiceStateProvince,
        practiceGroupName,
        phoneNumber,
        primaryContact,
        practiceEmail,
        practiceWebsite,
        practiceAddress,
        postalCode,
    };
};
const style = { width: '49%' };
const classes = 'p-3 hover-parent sc-glass sc-shadow sc-rounded text-white';

export default PracticeDetails;
